import { CheckRecord } from "./CheckRecord";
import { DepositRecord } from "./DepositRecord";
import { GiftCardRecord } from "./GiftCardRecord";
import { PaidinRecord } from "./PaidinRecord";
import { PaidoutRecord } from "./PaidoutRecord";
import { PaymentRecord } from "./PaymentRecord";
import { Store } from "./Store";

export class RevenueCenter {
	venueKey: number;
	ID: number;
	Name: string;

	Checks: CheckRecord[];

	PaidoutRecords: PaidoutRecord[];

	PaidinRecords: PaidinRecord[];

	GiftCardRecords: GiftCardRecord[];

	PaymentRecords: PaymentRecord[];

	DepositRecord: DepositRecord[];

	stores: Store;

	public constructor(init?: Partial<RevenueCenter>) {
		Object.assign(this, init);
	}

	count: number = 0;
	revenue: number = 0;
	voidTotal: number = 0;
}
